import React, { useState } from 'react'
import { Nav, Navbar, NavDropdown, Button, Modal } from 'react-bootstrap'
import { Auth } from '../logic/Auth'

interface HeaderProps {
    username: string | null
    isAdmin: boolean
}

function Header({ username, isAdmin }: HeaderProps) {
    return (
        <Navbar bg="light" expand="lg">
            <Navbar.Brand href="">Fin83</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                {username ? <NavigationBar isAdmin={isAdmin} /> : null}
            </Navbar.Collapse>
        </Navbar>
    )
}

function NavigationBar({ isAdmin }: { isAdmin: boolean }) {
    const [modal, setModal] = useState<string | null>(null)

    function logout() {
        setModal(null)
        Auth.clearCredentials()
        window.location.href = "/"
    }

    return <>
        {modal === "logout" && (
            <Modal show={true} onHide={() => setModal(null)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm logout?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Button variant="danger" onClick={logout}>Confirm logout</Button>{' '}
                    <Button variant="secondary" onClick={() => setModal(null)}>Cancel</Button>
                </Modal.Body>
            </Modal>
        )}
        <Nav className="mr-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <NavDropdown title="Movements" id="basic-nav-dropdown-movements">
                <NavDropdown.Item href="/movements/add">Add</NavDropdown.Item>
                <NavDropdown.Item href="/movements">List</NavDropdown.Item>
                <NavDropdown.Item href="/movements/import">Import</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/classification-rules">Automatic classification rules</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Budget" id="basic-nav-dropdown-budget">
                <NavDropdown.Item href="/report">Monthly report</NavDropdown.Item>
                <NavDropdown.Item href="/plan">Budget planning</NavDropdown.Item>
                <NavDropdown.Item href="/trend">Trend</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Investments" id="basic-nav-dropdown-investments">
                <NavDropdown.Item href="/investments/assets">Current portfolio</NavDropdown.Item>
                <NavDropdown.Item href="/investments/transactions">Transactions</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="/funds">Funds</Nav.Link>
        </Nav>
        <Nav className="ms-auto">
            <NavDropdown title="Account" id="basic-nav-dropdown-account">
                <NavDropdown.Item href="/settings">Settings</NavDropdown.Item>
                <NavDropdown.Item href="/tags">Tags</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={() => setModal("logout")}>Logout</NavDropdown.Item>
            </NavDropdown>
            {isAdmin && (
                <NavDropdown title="Admin" id="basic-nav-dropdown-admin">
                    <NavDropdown.Item href="/admin/users">Users</NavDropdown.Item>
                    <NavDropdown.Item href="/admin/currencies">Currencies</NavDropdown.Item>
                    <NavDropdown.Item href="/admin/sql">SQL</NavDropdown.Item>
                </NavDropdown>
            )}
        </Nav>
    </>
}

export default Header
